export default function (cpf) {
    cpf = (typeof cpf != 'string' ? cpf.toString() : cpf);
    cpf = cpf.padStart(11, '0');
    cpf = cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    return cpf;
}
